import React from "react";
import styles from "./Application.module.css";
import HeroSlider from "./HeroSlider/HeroSlider"

export const Application = () => {

    return (
        <div className={styles.container}>
            <div className={styles.heading}>
                <h1 className={styles.title}>Applications</h1>
            </div>
            <HeroSlider />
        </div>
    );
};